import React, { useEffect, useState } from 'react';
import AuthentificationApi from '../../api/AuthentificationApi';
import { sauvegarderRoleCourant } from '../../utils/auth';
import '../../fichierCss/FormulaireConnexion.css';

interface FormulaireConnexionProps {
  ouvert: boolean;
  fermeture: () => void;
  onMotDePasseOublie?: () => void;
}

const FormulaireConnexion = ({ ouvert, fermeture, onMotDePasseOublie }: FormulaireConnexionProps) => {
  const [courriel, setCourriel] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [afficherMotDePasse, setAfficherMotDePasse] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');

  useEffect(() => {
    if (!ouvert) {
      return undefined;
    }

    const gererTouche = (event) => {
      if (event.key === 'Escape') {
        fermeture();
      }
    };

    window.addEventListener('keydown', gererTouche);

    return () => {
      window.removeEventListener('keydown', gererTouche);
    };
  }, [ouvert, fermeture]);

  if (!ouvert) {
    return null;
  }

  const soumettreConnexion = async (event) => {
    event.preventDefault();
    setErreur('');
    setSucces('');
    setChargement(true);

    try {
      const resultat = await AuthentificationApi.connecter({
        courriel,
        motDePasse
      });

      if (resultat?.accessToken) {
        localStorage.setItem('accessToken', resultat.accessToken);
      }

      if (resultat?.refreshToken) {
        localStorage.setItem('refreshToken', resultat.refreshToken);
      }

      sauvegarderRoleCourant(resultat?.role || '');

      localStorage.setItem('userCourriel', courriel);

      window.dispatchEvent(new Event('auth-state-changed'));
      setSucces('Connexion reussie. Bienvenue.');
      setTimeout(() => {
        fermeture();
      }, 800);
    } catch (exception) {
      setErreur('Impossible de se connecter. Verifiez vos informations.');
    } finally {
      setChargement(false);
    }
  };

  return (
    <div
      className="connexion-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="titre-connexion"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          fermeture();
        }
      }}
    >
      <div className="connexion-modal-card">
        <button
          type="button"
          className="connexion-close"
          onClick={fermeture}
          aria-label="Fermer"
        >
          ×
        </button>

        <div className="connexion-badge">Bienvenue</div>
        <h2 id="titre-connexion">Connexion a votre espace</h2>
        <p className="connexion-subtitle">Retrouvez vos informations et vos actions en cours.</p>

        <form className="connexion-form" onSubmit={soumettreConnexion}>
          <label htmlFor="courriel">Courriel</label>
          <input
            id="courriel"
            type="email"
            value={courriel}
            onChange={(event) => setCourriel(event.target.value)}
            placeholder="nom@domaine.com"
            required
          />

          <div className="connexion-row-mot-de-passe">
            <label htmlFor="motDePasse">Mot de passe</label>
            <button
              type="button"
              className="connexion-oublie-link"
              onClick={(event) => {
                event.preventDefault();
                fermeture();
                if (onMotDePasseOublie) {
                  onMotDePasseOublie();
                }
              }}
            >
              Mot de passe oublie?
            </button>
          </div>
          <div className="champ-mot-de-passe">
            <input
              id="motDePasse"
              type={afficherMotDePasse ? 'text' : 'password'}
              value={motDePasse}
              onChange={(event) => setMotDePasse(event.target.value)}
              placeholder="Votre mot de passe"
              required
            />
            <button
              type="button"
              className="toggle-mdp"
              onClick={() => setAfficherMotDePasse((precedent) => !precedent)}
              aria-label={afficherMotDePasse ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
              {afficherMotDePasse ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              )}
            </button>
          </div>

          {erreur && <div className="connexion-feedback erreur">{erreur}</div>}
          {succes && <div className="connexion-feedback succes">{succes}</div>}

          <button type="submit" className="connexion-submit" disabled={chargement} translate="no">
            {chargement ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormulaireConnexion;
